import { Offcanvas } from 'bootstrap';
import LocomotiveScroll from 'locomotive-scroll';
import isCMSMode from './isCMSMode';
import { debounce } from 'lodash';
import { easing } from 'jquery';
import anime from 'animejs/lib/anime.es.js';
import $ from 'jquery';
import { isVisible } from './helper';


if (document.querySelectorAll('[data-scroll-container]').length && isCMSMode() == false) {
    const locoScrollOptions = {
        el: document.querySelector('[data-scroll-container]'),
        smooth: true,
        smartphone: { smooth: false },
        tablet: { smooth: true },
        lerp: 0.1,
        reloadOnContextChange: true,
    }

    let locoScroll = new LocomotiveScroll(locoScrollOptions);

    const targetNode = document.getElementById('scroll-container');
    const isDesktop = window.innerWidth > 1024 ? true : false;
    const config = { attributes: false, childList: true, subtree: true };

    const callback = function (mutationsList, observer) {
        let updateScroll = false;
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.target.classList.contains('videoBanner__date') == false) {
                updateScroll = true;
            }
        }
        if (updateScroll) {
            setTimeout(function () { locoScroll.update() }, 1000);
        }
    };

    const observer = new MutationObserver(callback);
    const videoBanner = document.querySelector('.videoBanner');
    const header = document.querySelector('.header');
    const exploreButton = document.querySelector('.videoBanner__explore');

    window.addEventListener("DOMContentLoaded", () => {
        locoScroll.update();
        observer.observe(targetNode, config);
        bookingMenuOnClick();
        scrollToFirstValidationError();

        returnToPreviousScrollPosition();

        document.querySelectorAll('.FormTextbox input, .FormTextbox textarea').forEach((elem) => {
            elem.addEventListener('keydown', checkKeyInputToPreventLocoScroll);
        });
    });

    // When the orientation is changed, reload the page
    //window.addEventListener("orientationchange", () => {
    //    setTimeout(function () {
    //        window.location.reload(true);
    //    }, 250);
    //});

    window.addEventListener("recalculateScroll", () => {
        locoScroll.update();
    });

    window.addEventListener('LocoScrollStoppedScrolling', () => {
        window['scrolInstance'].update();
    });

    document.addEventListener('prevent-select2-scroll-on', () => {
        window['scrolInstance'].start();
    });

    document.addEventListener('prevent-select2-scroll-off', () => {
        window['scrolInstance'].stop();
    });

    const restartLocomotiveScroll = debounce(() => {
        window['scrolInstance'].update();
    }, 200);

    window.addEventListener("resize", () => {

        if (!isDesktop && window.innerWidth > 1024) {
            location.reload();
        } else if (isDesktop && window.innerWidth <= 1024) {
            isDesktop = false;
        }
        restartLocomotiveScroll();
    })

    function isInViewport(element) {
        const rect = element.getBoundingClientRect();

        // Check to make sure top is above 0 to fix issue where videos were being classed as inview when they werent
        return (
            rect.top > 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    function bookingButtonClick() {
        locoScroll.stop();
    }

    function closeBookingClick() {
        locoScroll.start();
    }

    function bookingMenuOnClick() {
        const bookingButtons = document.querySelectorAll('.js-room-button');
        bookingButtons.forEach(button => {
            button.addEventListener('click', bookingButtonClick)
        })

        const closeBookingButton = document.querySelector('.js-booking-close')
        if (closeBookingButton) {
            closeBookingButton.addEventListener('click', closeBookingClick)
        }
    }

    function returnToPreviousScrollPosition() {

        if (localStorage.getItem(window.location.pathname) != null) {
            const scrollPosition = parseInt(localStorage.getItem(window.location.pathname));

            if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
                window['scrolInstance'].scrollTo(scrollPosition, { duration: 1000 });
            }
        }
    }

    function scrollToFirstValidationError() {

        var selectButton = document.querySelector('.FormSubmitButton ');

        if (selectButton) {
            selectButton.addEventListener('click', function (e) {
                setTimeout(() => {
                    const visibleErrors = Array.from(document.querySelectorAll('.Form__Element__ValidationError')).filter(elem => isVisible(elem) === true);
                    if (visibleErrors.length > 0) {
                        e.preventDefault();
                        e.stopPropagation();
                        const headerHeight = document.querySelector('header.header').clientHeight || 0;
                        const scrollLocation = visibleErrors[0].parentNode.getBoundingClientRect().top + window['scrolInstance'].scroll.instance.scroll.y - headerHeight;
                        window['scrolInstance'].scrollTo(scrollLocation, { duration: 1000 });
                    }
                }, 1); // Delay is to allow DOM elements to be updated visually
            });
        }
    }

    function carouselExpand(heroImage, distanceToTop) {

        const heightFromTop = heroImage.getBoundingClientRect().top;
        const transformValue = (((distanceToTop - heightFromTop) / (distanceToTop)) * 100);

        const defaultWidth = 91
        const updatedTransform = !transformValue.toString().includes("-") ? transformValue : 0;
        const widthPercentage = (updatedTransform / (100 - defaultWidth));

        if (widthPercentage < 9) {
            heroImage.style['-webkit-mask-size'] = 91 + widthPercentage + '% 100%';
        } else if (widthPercentage >= 9) {
            heroImage.style['-webkit-mask-size'] = '101% 100%';
        }
    }

    // This technique is used to prevent locoscroll from firing when the user presses certain keys inside input fields
    function checkKeyInputToPreventLocoScroll(event) {
        if (event.key === 'Home' || event.key === 'End') {
            event.stopImmediatePropagation();
        }
    }

    let distanceToTop = [];
    let heroImages = document.querySelectorAll('.hero-image, .promoBlock__video');

    document.addEventListener("VideoVueComponentMounted", () => {
        heroImages = document.querySelectorAll('.hero-image, .promoBlock__video');
    });

    locoScroll.on('scroll', (args) => {


        if (heroImages.length > 0) {

            heroImages.forEach(function (image, index) {

                if (image.classList.contains("video--mobile") && window.innerWidth > 768) return;
                if (image.classList.contains("video--desktop") && window.innerWidth < 768) return;

                if (distanceToTop.length < index + 1 && isInViewport(image)) {
                    const distanceTopTopValue = image.getBoundingClientRect().top
                    distanceToTop.push(distanceTopTopValue);
                }

                carouselExpand(image, distanceToTop[index]);
            });

            if (args.scroll.y !== 0) {
                localStorage.setItem(window.location.pathname, args.scroll.y);
            }


        }
        if (videoBanner !== null) {

            let videoBannerPosition = videoBanner.getBoundingClientRect();
            if (exploreButton != null) {
                if ((args.scroll.y) >= videoBannerPosition.top + 200 && args.scroll.y >= videoBannerPosition.top) {
                    exploreButton.classList.add('is-hidden')
                } else {
                    exploreButton.classList.remove('is-hidden');
                }
            }

            if (!header.classList.contains('header--mobilenav-open')) {
                const scrollBannerPercentage = ((args.scroll.y + 1) / videoBannerPosition.height); // 0.0-1.0
                const tallScreenBannerStillPartiallyOnScreen = (args.scroll.y <= 250 && args.scroll.y >= videoBannerPosition.top && window.innerHeight >= 800); // If the banner is still on screen for taller screen
                const shortScreenPastPercentageOfBanner = (scrollBannerPercentage < 0.15 && window.innerHeight < 800); // If on a short screen and scrolled past half height of banner 

                if (tallScreenBannerStillPartiallyOnScreen || shortScreenPastPercentageOfBanner) {
                    header.classList.remove('header--white');
                    header.classList.add('header--transparent');
                } else {
                    header.classList.remove('header--transparent');
                    header.classList.add('header--white');
                }
            }
        }
    });

    window['scrolInstance'] = locoScroll;

    // Accordion scrollTo attempt - Only triggering once?
    //const scrollTarget = document.querySelector('.card-header');
    //const accordionToggle = document.querySelector('.collapse__toggle');



    //accordionToggle.addEventListener('click', function (e) {
    //    if (!event.target.matches('.collapse__toggle')) return;
    //    event.preventDefault();

    //    //locoScroll.scrollTo(
    //    //    scrollTarget, {
    //    //        offset: -1000,
    //    //        disableLerp: true
    //    //});

    //    setTimeout(function () {
    //        locoScroll.scrollTo(scrollTarget);
    //    });
    //    locoScroll.update();
    //});

    if (exploreButton) {

        exploreButton.addEventListener('click', () => {
            const exploreButtonTarget = document.querySelector('#scroll-target');
            const options = { offset: -20 };

            if (window.site === 'emory' && window.innerWidth >= 990) {
                options.offset = -95;
            } else if (window.site === 'emory') {
                options.offset = -50;
            }

            locoScroll.scrollTo(exploreButtonTarget, options);

        })
    }

    // Recalculate heights for locoscroll after videos have loaded.
    const splitVideos = document.querySelectorAll(".splitVideo__video");
    splitVideos.forEach(video => {
        video.addEventListener("playing", (event) => {
            if (event.target.classList.contains('has-played') == false) {
                const customScrollEvent = new Event('recalculateScroll');
                window.dispatchEvent(customScrollEvent);
                event.target.classList.add('has-played');
            }
        });
    });
}